import {
  type UseParseContentForDisplayQSetReviewInput,
  useParseContentForDisplayQSetReview,
} from './content-parser';

export function useParseContentForExamCourseComment(
  params: UseParseContentForDisplayQSetReviewInput,
) {
  const { taskId } = params;
  const { parseContentForDisplay: parseContentForQSet } = useParseContentForDisplayQSetReview({
    taskId,
  });

  return {
    parseContentForQSet,
  };
}
